import { useQuery } from '@tanstack/react-query';
import { getEcommGenderCategoryReport ,type GenderEcommCategoryReport } from "../services/ecommGenderCategService";


export const useEcommGenderCategoryReport = (start_date: string, end_date: string) => {
  return useQuery<GenderEcommCategoryReport[], Error>({
    queryKey: ['ecomm-gender-category', start_date, end_date],
    queryFn: () => getEcommGenderCategoryReport(start_date, end_date),
    staleTime: 1000 * 60 * 5,
  });
};